var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('LineChartGenerator',{attrs:{"id":"my-chart-id","chartData":_vm.chartDataComputed,"styles":{ width:'100%'}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }